import { Link, Typography } from '@mui/material';

interface NavigationExternalLinkProps {
    url: string | undefined;
    label: string | undefined;
}

export default function NavigationExternalLink({ url, label }: NavigationExternalLinkProps) {
    if (!url || !label) {
        return null;
    }

    return (
        <Typography component={ Link }
            href={ url }
            target="_blank"
            variant="body2"
            sx={{ textDecoration: 'none' }}
        >
            { label }
        </Typography>
    );
}
